module.exports = __webpack_public_path__ + "img/mission.667ba24f.svg";